let baseUri = "https://hwy.328ym.com/cms/"
// let baseUri = "https://dev.328ym.com/cms";

export const baseUrl = baseUri;
